import { FETCH_AMAZON_REVERSE_SHARING, RECEIVE_AMAZON_REVERSE_SHARING, RECEIVE_AMAZON_REVERSE_SHARING_ERROR } from 'constants/reduxActions';
import type { AmazonReverseSharingAction } from 'actions/amazonReverseSharing';

export interface AmazonReverseSharingProduct {
  brandName: string;
  imageId: string;
  link: string;
  msaImageId: string;
  onHand: number;
  originalPrice: string;
  percentOff: string;
  price: string;
  productId: string;
  productName: string;
  productSeoUrl: string;
  productUrl: string;
  styleId: string;
}

export interface AmazonReverseSharingState {
  data: { linkedStyles: AmazonReverseSharingProduct[]; productId: string } | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: AmazonReverseSharingState = {
  data: null,
  isLoading: false,
  error: null
};

export default function amazonReverseSharing(
  state: Readonly<AmazonReverseSharingState> = initialState,
  action: AmazonReverseSharingAction
): AmazonReverseSharingState {
  switch (action.type) {
    case FETCH_AMAZON_REVERSE_SHARING:
      return { ...state, isLoading: true, error: null };
    case RECEIVE_AMAZON_REVERSE_SHARING:
      return { ...state, isLoading: false, data: action.data, error: null };
    case RECEIVE_AMAZON_REVERSE_SHARING_ERROR:
      return { ...state, isLoading: false, error: action.error };
    default:
      return state;
  }
}
